// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddressBox_wrapper__XPCrb","btnWrapper":"AddressBox_btnWrapper__257QL"};